import { useApi } from "./useApi";

export const useLeagues = () => {
  const { client } = useApi();

  const getLeagues = async (active = "true") => {
    try {
      const codes = await client.get(`/v1/leagues?active=${active}`);
      return codes;
    } catch (err) {
      return null;
    }
  };

  const updateLeagueStatus = async (id, status) => {
    try {
      await client.patch("/v1/leagues", {
        id,
        status,
      });
    } catch (err) {
      return null;
    }
  };

  const getNextMatches = async (league, season) => {
    try {
      const matches = await client.get(
        `/v1/leagues/matches?league=${league}&season=${season}`,
      );
      return matches;
    } catch (err) {
      return null;
    }
  };

  return { getLeagues, getNextMatches, updateLeagueStatus };
};
